import React, { PropsWithChildren } from 'react';

import { ColumnContainer, Header, StyledInfoAreaContainer, TinyText } from './LMPEntered.styled';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { formatDate } from 'utilities/formatDate';

import { PregnancyCalculatorActionButtons } from './PregnancyCalculatorActionButtons';
import { TileWidget } from './TileWidget';
import { formatGestationalAges } from '../utils/format-gestational-age';

interface Props {
  onCancelClick?: () => void;
  gestationalAgeInDays: number;
  estimatedDueDate: Date;
}

export const LMPEntered: React.FC<PropsWithChildren<Props>> = ({
  onCancelClick,
  gestationalAgeInDays,
  estimatedDueDate
}: Props) => (
  <TileWidget state="lmp-entered">
    <Header>
      <Text fontStyle="regular" size="lg">
        You are now...
      </Text>
      <Heading tag="div" styledAs="h2" noMargin>
        {formatGestationalAges(gestationalAgeInDays)}
      </Heading>
      <Text fontStyle="regular" size="lg">
        into your pregnancy!
      </Text>
    </Header>

    <StyledInfoAreaContainer>
      <ColumnContainer>
        <Text fontStyle="regular" size="xs">
          Estimated Due Date
        </Text>
        <Heading tag="div" styledAs="h2" noMargin>
          {formatDate(estimatedDueDate, 'MMM D')}
        </Heading>
      </ColumnContainer>
    </StyledInfoAreaContainer>
    <TinyText>These dates will change.</TinyText>
    <PregnancyCalculatorActionButtons onCancelClick={onCancelClick} />
  </TileWidget>
);
